/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef} from 'react'
import {getCustomer} from '../../../../api/modules/getdatalist'
import {createEndUser} from '../../../../api/modules/master-data/master_2'
import {Link} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useTranslation, initReactI18next} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import axios from 'axios'
import Pagination from '../../component/Pagination'
import {Spinner} from 'react-bootstrap'
import {PageTitle} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'

type Props = {
  className: string
}

const AddEnduser: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const intl = useIntl()

  const [fullCustomer, setFullCustomer] = useState<any[]>([])
  const [showCust, setShowCust] = useState(false)
  const [customer, setCustomer] = useState('')
  const [custID, setCustID] = useState(0)
  const [name, setName] = useState('')
  const navigate = useNavigate()
  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    const getCust = async () => {
      await getCustomer('', '').then((res) => {
        setFullCustomer(res.data.data.data)
      })
    }
    getCust()
  }, [])

  const handleUpload = async () => {
    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        setBtnLoading(true)
        let active = 0
        const ckbox = document.getElementById('ckbox') as HTMLInputElement
        if (ckbox != null) {
          if (ckbox.checked) active = 1
          else active = 0
        }
        const payload = {name: name, status: active}
        await createEndUser(payload)
          .then((res: any) => {
            swal({
              title: `${t('Data Added Successfully')}`,
              icon: 'success',
            }).then(() => navigate('/master/enduser'))
          })
          .catch((error: any) => {
            swal({
              closeOnClickOutside: false,
              title: t(error.response.data.message),
              icon: 'error',
            })
          })
          .finally(() => {
            setBtnLoading(false)
          })
      }
    })
  }

  const [numberURL, setNumberURL] = useState([])

  const paginateNumber = async (number: any) => {
    const res = await axios.get(`${number}&customer_code=${custNum}&name=${custName}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
    setFullCustomer(res.data.data.data)
    setNumberURL(res.data.data.links)
  }

  const [custName, setCustName] = useState('')
  const [custNum, setCustNum] = useState('')

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getCustomer(custName, custNum).then((res: any) => {
        setFullCustomer(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [custName, custNum])

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({
          id: `• ${t('Master Data')} • ${t('order-tambah')} • ${t('End_User')} `,
        })}
      </PageTitle>
      <div className={`card mx-10 ${className}`}>
        {/* <div className='ps-8 pt-8'>
                <div>
                    <p className='mt-5'>
                        <i className='fw-normal'>
                            End User/<span className='text-primary fw-normal'>{t('order-tambah')} End User</span>
                        </i>
                    </p>
                    <h1 className='fw-semibold'>{t('order-tambah')} End User</h1>
                </div>
            </div> */}

        <div className='card-body mx-10 mt-3'>
          {/* <Row className='mb-3'>
                    <Col md='2'><p className='fs-4 mt-2'>{t('order-pembeli')}</p>
                    </Col>
                    <Col md='10'>
                        <div className='d-flex align-items-center'>
                            <Form.Control   disabled value={customer} size="sm" />
                            <Button variant='primary' className='ms-1 px-2' onClick={() => setShowCust(true)}>{t('Browse')}</Button>
                        </div>
                    </Col>
                </Row> */}

          <Row className='mb-4'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('End_User_Name')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Control
                  type='text'
                  placeholder={t('End_User_Name')}
                  onChange={(e: any) => setName(e.target.value)}
                  size='sm'
                />
              </div>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('Address')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Control
                  type='text'
                  placeholder={t('Address')}
                  onChange={(e: any) => setName(e.target.value)}
                  size='sm'
                />
              </div>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('City')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Control
                  type='text'
                  placeholder={t('City')}
                  onChange={(e: any) => setName(e.target.value)}
                  size='sm'
                />
              </div>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('Province')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Control
                  type='text'
                  placeholder={t('Province')}
                  onChange={(e: any) => setName(e.target.value)}
                  size='sm'
                />
              </div>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('Phone Number')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Control
                  type='text'
                  placeholder={t('Phone Number')}
                  onChange={(e: any) => setName(e.target.value)}
                  size='sm'
                />
              </div>
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('Email')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Control
                  type='text'
                  placeholder={t('Email')}
                  onChange={(e: any) => setName(e.target.value)}
                  size='sm'
                />
              </div>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('Segment')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Control
                  type='text'
                  placeholder={t('Segment')}
                  onChange={(e: any) => setName(e.target.value)}
                  size='sm'
                />
              </div>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('Bidang Usaha')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Control
                  type='text'
                  placeholder={t('Bidang Usaha')}
                  onChange={(e: any) => setName(e.target.value)}
                  size='sm'
                />
              </div>
            </Col>
          </Row>

          <Row className='mb-3'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('active')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Check reverse className='mt-5 mb-2' type='checkbox' id='ckbox' />
              </div>
            </Col>
          </Row>
        </div>

        <div className='d-flex mx-10 justify-content-end p-8'>
          <Link to={'/master/enduser'}>
            <Button className='btn btn-secondary me-2'>{t('berita-batal')}</Button>
          </Link>
          <Button className='btn btn-primary' onClick={() => handleUpload()} disabled={btnLoading}>
            {btnLoading ? (
              <Spinner animation='border' variant='light' size='sm' />
            ) : (
              t('order-kirim')
            )}
          </Button>
        </div>

        <Modal
          show={showCust}
          onHide={() => setShowCust(false)}
          centered
          backdrop='static'
          keyboard={false}
          size='lg'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Browse')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive bdr'>
              <Row className='mb-4'>
                <Col md={6}>
                  <Form.Label>{t('Customer Number')}</Form.Label>
                  <Form.Control
                    aria-label='Default select example'
                    id='searchpo'
                    placeholder={t('Search Customer Number')}
                    size='sm'
                    onChange={(e: any) => setCustName(e.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <Form.Label>{t('Customer Name')}</Form.Label>
                  <Form.Control
                    aria-label='Default select example'
                    id='searchpo'
                    placeholder={t('Search Customer Name')}
                    size='sm'
                    onChange={(e: any) => setCustNum(e.target.value)}
                  />
                </Col>
              </Row>
              <table className='table table-striped table-hover'>
                <thead>
                  <tr>
                    <th className='text-center'></th>
                    <th className='text-center'>{t('Customer Number')}</th>
                    <th className='text-center'>{t('Customer Name')}</th>
                  </tr>
                </thead>
                <tbody>
                  {fullCustomer?.map((item: any, index: number) => {
                    return (
                      <tr key={item?.id ?? index}>
                        <td className='text-center'>
                          <Form.Check
                            reverse
                            type='checkbox'
                            id={item?.customer_code}
                            onChange={(e: any) => {
                              setCustomer(item.name)
                              setCustID(item.customer_code)
                              setShowCust(false)
                            }}
                          />
                        </td>
                        <td className='text-center'>{item.customer_code}</td>
                        <td className='text-center'>{item.name}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
              <div className='my-5'>
                <Pagination paginate={paginateNumber} test={numberURL} />
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  )
}

export {AddEnduser}
